"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("../../../actions/user/types");
function isLoggedOut() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (action.type === "".concat(_types.GET_USER_FROM_SESSION, "_FAILURE")) {
    return true;
  }
  return state;
}
var _default = exports["default"] = isLoggedOut;